var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_38594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6101 0.104492L50.9292 16.295L65.363 5.93314L63.6061 23.6141L81.2871 21.8573L70.9251 36.291L87.1158 43.6101L70.9251 50.9292L81.2871 65.363L63.6061 63.6061L65.363 81.2871L50.9292 70.9251L43.6101 87.1158L36.291 70.9251L21.8573 81.2871L23.6141 63.6061L5.93314 65.363L16.295 50.9292L0.104492 43.6101L16.295 36.291L5.93314 21.8573L23.6141 23.6141L21.8573 5.93314L36.291 16.295L43.6101 0.104492Z",
    fill: "#1F274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7334 51.1227L48.6282 41.1255L50.6542 42.2952L48.0532 50.7037L47.7929 50.1857L48.8838 50.8156L48.257 50.8214L53.6681 44.4668L55.2985 45.4081L48.7185 52.8461L45.7334 51.1227ZM50.9482 54.1335L53.9678 44.6399L55.6821 45.6296L53.0882 53.6107L52.7919 53.0719L53.8348 53.6741L53.28 53.7215L59.0458 47.1401L60.9639 48.2476L53.9932 55.8915L50.9482 54.1335Z",
    fill: "#FFEA24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1709 46.1796L42.2235 37.4282L44.1416 38.5356L39.089 47.287L37.1709 46.1796ZM38.8492 47.1486L39.7905 45.5182L43.6148 47.7261L42.6735 49.3565L38.8492 47.1486ZM40.9464 43.5161L41.8877 41.8858L45.4362 43.9345L44.4949 45.5649L40.9464 43.5161ZM42.9605 40.0276L43.9018 38.3972L47.6421 40.5567L46.7008 42.187L42.9605 40.0276Z",
    fill: "#FFEA24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6514 40.1058L31.704 31.3545L34.9287 33.2163L34.0934 42.2767L34.501 42.512L34.1366 42.5893L38.3932 35.2166L40.2395 36.2825L35.1869 45.0338L31.9381 43.1582L32.7734 34.0979L32.3658 33.8626L32.7302 33.7852L28.4736 41.1579L26.6514 40.1058Z",
    fill: "#FFEA24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_38594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNew);
export default __webpack_public_path__ + "static/media/card-new.6edb07c3d5e8d7b3de1309cf011cbef0.svg";
export { ForwardRef as ReactComponent };